import { request } from '../request';

/**
 * 获取客户列表
 *
 * @param data
 * @returns
 */
export const fetchPostCustomersList = (data?: Api.Customers.ClientParams) => {
  return request<Api.Customers.ClientList>({
    url: '/developer-platform/api/tenant/detail/page',
    method: 'post',
    data
  });
};

/**
 * 获取客户详情
 *
 * @param tenantId
 * @returns
 */
export const fetchGetCustomersDetail = (tenantId: string) => {
  return request<Api.Customers.Clients>({
    url: '/developer-platform/api/tenant/detail',
    method: 'get',
    params: {
      clientId: tenantId
    }
  });
};

/**
 * 用户公司信息
 *
 * @returns
 */
export const fetchGetCompanyInfo = () => {
  return request<Api.Customers.Clients>({
    url: '/developer-platform/api/user/getCompanyInfo',
    method: 'get'
  });
};

/**
 * 获取客户管理员详情
 *
 * @param tenantId
 * @returns
 */
export const fetchGetCustomersDetailAdmin = (tenantId: string) => {
  return request<any>({
    url: '/developer-platform/api/tenant/detail/admin',
    method: 'get',
    params: {
      clientId: tenantId
    }
  });
};

/**
 * 新增客户信息
 *
 * @param data
 * @returns
 */
export const fetchPostCustomersAdd = (data: Api.Customers.Clients) => {
  return request<Api.Customers.ClientList>({
    url: '/developer-platform/api/tenant/add',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data
  });
};

/**
 * 更新客户信息
 *
 * @param params
 * @returns
 */
export const fetchPostCustomersUpdate = (data: Api.Customers.Clients) => {
  return request<any>({
    url: '/developer-platform/api/tenant/update',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });
};

/**
 * 更新用户公司信息
 *
 * @param params
 * @returns
 */
export const fetchPostCompanyUpdate = (data: Api.Customers.Clients) => {
  return request<any>({
    url: '/developer-platform/api/user/updateCompanyInfo',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  });
};

/**
 * 更新客户管理员信息
 *
 * @param params
 * @returns
 */
export const fetchPostCustomersAdminUpdate = data => {
  return request({
    url: '/developer-platform/api/tenant/update/administrator',
    method: 'post',
    data
  });
};

/**
 * 更新客户使能状态
 *
 * @param data
 * @returns
 */
export const fetchPostCustomersEnableUpdate = params => {
  return request({
    url: '/developer-platform/api/tenant/update/enable',
    method: 'post',
    params
  });
};

/**
 * 删除客户
 *
 * @param tenantId
 * @returns
 */
export const fetchDeleteCustomers = (tenantId: string) => {
  return request({
    url: '/developer-platform/api/tenant/delete',
    method: 'delete',
    params: {
      clientId: tenantId
    }
  });
};


/**
 * 清空oem配置
 */
export function fetchClearOemConfig(data: any) {
  return request({
    url: '/developer-platform/api/tenant/clearOemConfig',
    method: 'POST',
    data
  });
}
